import { useEffect, useState } from 'react';
import {
  getReportsPotentialParticipants,
  IPostAddParticipantBody,
  postAddParticipant } from '../services/surveys';


export const useAddNewParticipantForm = (surveyId: string, groupId: string) => {
  const [list, setList] = useState([]);
  const [apiErrors, setApiErrors] = useState<Record<string, string> | null>(null);

  const fetchPotentialParticipants = async (phrase?: string) => {
    try {
      const participantsList = await getReportsPotentialParticipants(
        surveyId,
        groupId,
        {name: phrase}
      );
      setList(participantsList?.items || []);
      setApiErrors(null);
    } catch (e) {
      setApiErrors(e as Record<string, string>);
    }
  };

  const addPotentialParticipant = async (body: IPostAddParticipantBody) => {
    await postAddParticipant(body, surveyId, groupId);
  };

  useEffect(() => {
    (async () => await fetchPotentialParticipants())();
  }, []);

  return {
    list,
    apiErrors,
    fetchPotentialParticipants,
    addPotentialParticipant
  };

};
